import React from 'react';
import { Button } from './ui/Button';
import { Star, ShieldCheck, Clock } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-4 pb-20 overflow-hidden" data-id="element-32">
      {/* Background image — blurred */}
      <div className="absolute inset-0 z-0" data-id="element-33">
        <img src="https://cdn.magicpatterns.com/uploads/cGhT7rShwm59nEU1p4D2rV/Firefly_Gemini_Flash_Sacale_el_texto_119180.png" alt="" className="w-full h-full object-cover object-center scale-105" style={{
        filter: 'blur(6px)'
      }} data-id="element-34" />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-blue-950/60" data-id="element-35" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-36">
        <div className="max-w-4xl mx-auto" data-id="element-37">
          {/* Badge */}
          <div className="text-center mb-6" data-id="element-38">
            <div className="inline-flex items-center gap-2 text-sm font-semibold bg-amber-400/20 border border-amber-400/40 text-amber-300 px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-39">
              <span className="text-lg" data-id="element-40">⚖️</span>
              <span data-id="element-41">Sistema completo para docentes argentinos</span>
            </div>
          </div>

          {/* Title */}
          <div className="text-center mb-10" data-id="element-42">
            <h1 className="text-[22px] leading-[1.2] sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight max-w-3xl mx-auto drop-shadow-lg" data-id="element-43">
              Organizá todo tu año de Derecho y{' '}
              <span className="text-amber-400" data-id="element-44">
                ahorrá hasta 12 meses de planificación
              </span>{' '}
              con el{' '}
              <span className="text-amber-300" data-id="element-45">Mega Pack DERECHO 360</span>
            </h1>
          </div>

          {/* Image */}
          <div className="mb-8" data-id="element-46">
            <div className="relative z-10 transform transition-transform hover:scale-105 duration-500 cursor-pointer max-w-2xl mx-auto" onClick={scrollToPricing} data-id="element-47">
              <img src="https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png" alt="Derecho 360 Pack Completo" className="w-full drop-shadow-2xl" data-id="element-48" />
            </div>
          </div>

          {/* Product Title and Description */}
          <div className="text-center mb-10" data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-extrabold text-amber-400 mb-4 drop-shadow-md" data-id="element-50">
              DERECHO 360
            </h2>
            <p className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed" data-id="element-51">
              Sistema completo de proyectos, experiencias y evaluaciones listas
              para usar.{' '}
              <strong className="text-white" data-id="element-52">
                Todo tu año de Derecho resuelto en un clic.
              </strong>
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10" data-id="element-53">
            <Button onClick={scrollToPricing} size="xl" withIcon data-id="element-54">
              QUIERO ACCESO INMEDIATO
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium" data-id="element-55">
            <div className="flex items-center gap-2 text-blue-100" data-id="element-56">
              <ShieldCheck className="h-5 w-5 text-green-400" data-id="element-57" />
              <span data-id="element-58">Compra 100% Segura</span>
            </div>
            <div className="flex items-center gap-2 text-blue-100" data-id="element-59">
              <Clock className="h-5 w-5 text-amber-400" data-id="element-60" />
              <span data-id="element-61">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}